var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocusign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.945.043H.02v30.926h30.925zm0 0",
    fill: "#d5ff00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.645 23.664H4.316v3.008h22.329zm0 0M15.484 21.945l2.125-2.12 6.465-6.47-2.152-2.144-4.938 4.937V3.906h-3.007v12.242l-4.938-4.937-2.148 2.144 6.464 6.47zm0 0"
  })));
}
export default SvgDocusign;